import { post } from '@/util/request'

export default {
    /**
     * 报送专题接口
     * */
    taskList: query => post(`/report/listTree`, query),
	/**
	 * 报送城市接口
	 * */
	cityList: query => post(`/report/cityList`, query),
	/**
	 * 上报接口
	 * **/
    addArticle: query => post(`/report/addArticle`, query),
    /**
     * 上报接口
     * **/
    checkUrl: query => post(`/report/checkUrl`, query),
    /**
     * 舆情级别
     * **/
    dictionaryList: query => post(`/report/dictionaryList`, query),
	



}
